// B-NEW-2 fix (Niranjan, Feb 2026) — blob-aware axios error parsing.
//
// When an axios request uses `responseType: 'blob'` and the server
// returns a 4xx/5xx with a JSON body (e.g. {detail: "..."}), the
// error.response.data is a Blob, not a string. Calling JSON.parse on
// it throws TypeError; calling .text() works but is async.
//
// `parseAxiosError(err)` resolves to a friendly string we can pass
// straight to `toast.error(...)` regardless of responseType.
//
// `withTimeout(config, ms = 30000)` — also exported here per
// B-NEW-3 FIX-3A so every export request has a 30 s ceiling and
// the parent component's `exporting` state can be reset cleanly
// in the finally block.

export async function parseAxiosError(err, fallback = 'Request failed') {
  if (err?.response?.data instanceof Blob) {
    try {
      const text = await err.response.data.text();
      try {
        const j = JSON.parse(text);
        return j.detail || j.message || text || fallback;
      } catch {
        return text || fallback;
      }
    } catch {
      return fallback;
    }
  }
  return (
    err?.response?.data?.detail
    || err?.response?.data?.message
    || err?.message
    || fallback
  );
}

export function withTimeout(config = {}, ms = 30000) {
  return { timeout: ms, ...config };
}
